import React, {PureComponent} from "react";
import PubSub from 'pubsub-js';
import {Breadcrumb, BreadcrumbItem, Col, Row} from "reactstrap";
import Widget from '../../components/Widget';
import TimeFilter from './../../components/filter/TimeFilter'
import LoadingModal from './../../components/filter/LoadingModal'
import {MonthFilter} from './../../components/filter/MonthFilter'
import {SectionalFilter} from './../../components/filter/SectionalFIlter'
import {DetailSales} from './components/DetailSales';

export default class SalesEffectiveness extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data : [],
            maxYear: 2023,
            mes : 2,
            sectional : 'ARMENIA',
            showModal: false
        };
        this.onChangehandle = this.onChangehandle.bind(this);
        this.onChangehandlemonth = this.onChangehandlemonth.bind(this);
        this.onChangehandlesectional = this.onChangehandlesectional.bind(this);
    }

    onChangehandle(e){
        console.log(e.target.value)
        this.setState({
            maxYear: e.target.value
        }, () => {
            PubSub.publish('reloadmaxYear', 'Reloading maxYear');
        })
    }

    onChangehandlemonth(e){
        console.log(e.target.value)
        this.setState({
            mes: e.target.value
        }, () => {
            PubSub.publish('reloadmes', 'Reloading mes');
        })
    }

    onChangehandlesectional(e){
        console.log(e.target.value)
        this.setState({
            sectional: e.target.value
        }, () => {
            PubSub.publish('reloadsectional', 'Reloading sectional');
        })
    }


    onLoading = (showModal) => {
        this.setState({
            showModal: showModal
        })
    }

    render() {
        return(

            <div>
                <Breadcrumb>
                    <BreadcrumbItem>Estás en</BreadcrumbItem>
                    <BreadcrumbItem active>Efectividad Ventas</BreadcrumbItem>
                </Breadcrumb>
                <h1 className="page-title mb-lg">Efectividad <span className="fw-semi-bold">Ventas</span></h1>
                <LoadingModal show={this.state.showModal}/>
                <Row>

                    <Col xs={12} md ={4}>
                        <Widget>
                            <TimeFilter
                                handleChange={this.onChangehandle}
                                onLoading={this.onLoading}
                            />
                        </Widget>
                    </Col>
                    <Col xs={12} md ={4}>
                        <Widget>
                            <MonthFilter
                                handleChangemonth={this.onChangehandlemonth}
                                onLoading={this.onLoading}
                            />
                        </Widget>
                    </Col>
                    <Col xs={12} md ={4}>
                        <Widget>
                            <SectionalFilter
                                handleChangesectional={this.onChangehandlesectional}
                                onLoading={this.onLoading}
                            />
                        </Widget>
                    </Col>
                </Row>
                {this.state.maxYear ?
                    <DetailSales
                        maxYear={this.state.maxYear}
                        mes = {this.state.mes}
                        sectional = {this.state.sectional}
                        onLoading={this.onLoading}
                    /> : null}
            </div>
        )
    }
}